<div class="main-warpper">
    <app-header></app-header>
    <!-- <div style="min-height: 550px" class="grey-bg"> -->
    <div class="grey-bg">
        <router-outlet></router-outlet>
    </div>
    <div class="footerPos">
        <app-footer></app-footer>
    </div>    
</div>